<td class="truncate" [title]="fileName">{{fileName}}</td>
<td class="truncate" [title]="statusMessage">{{statusMessage}}</td>
<td class="nowrap"  >{{uploaded}}</td>
<td class="truncate" [title]="hmlId">{{hmlId}}</td>
<td class="nowrap"
    [ngClass]="actionCss"
    (click)='executeAction()'>
    <throbber *ngIf='isActionPending()'></throbber>
    <span id="action" *ngIf='!isActionPending()'>{{actionString}}</span>
</td>
